import { render, staticRenderFns } from "./PersonalLayout.vue?vue&type=template&id=60834041&"
import script from "./PersonalLayout.vue?vue&type=script&lang=js&"
export * from "./PersonalLayout.vue?vue&type=script&lang=js&"
import style0 from "./PersonalLayout.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports